import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ColaboradorService extends BaseService {
  constructor() {
    super(`${ConfigApi.colaboradorURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.email = '';
    this.idColaboradorVinculo = undefined;
    this.idColaboradorPerfil = undefined;
    this.inativo = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new ColaboradorService();
